const WHITELIST_REQUEST = 'WHITELIST_REQUEST';
const WHITELIST_SUCCESS = 'WHITELIST_SUCCESS';
const WHITELIST_FAIL = 'WHITELIST_FAIL';

const CREATE_WHITELIST_REQUEST = 'CREATE_WHITELIST_REQUEST';
const CREATE_WHITELIST_SUCCESS = 'CREATE_WHITELIST_SUCCESS';
const CREATE_WHITELIST_FAIL = 'CREATE_WHITELIST_FAIL';

const DELETE_WHITELIST_REQUEST = 'DELETE_WHITELIST_REQUEST';
const DELETE_WHITELIST_SUCCESS = 'DELETE_WHITELIST_SUCCESS';
const DELETE_WHITELIST_FAIL = 'DELETE_WHITELIST_FAIL';

export const whitelistAction = {
    WHITELIST_REQUEST,
    WHITELIST_SUCCESS,
    WHITELIST_FAIL,
    CREATE_WHITELIST_REQUEST,
    CREATE_WHITELIST_SUCCESS,
    CREATE_WHITELIST_FAIL,
    DELETE_WHITELIST_REQUEST,
    DELETE_WHITELIST_SUCCESS,
    DELETE_WHITELIST_FAIL
}
